module.exports = __webpack_public_path__ + "static/media/leaderboard.12fdc6fd.jpg";